import { IModalEntity } from "./interface";
import store from '@/store';
import { MODAL_MODULE_NAME } from "@/store/modules/modal";

export const modalEntity = {

	get modalState(): IModalEntity | null {
		return store.getters[`${MODAL_MODULE_NAME}/modal`];
	},

	set modalState(v: IModalEntity | null) {
		store.commit(`${MODAL_MODULE_NAME}/setModal`, v);
	}

};